/**
 * Konta w aplikacji: dwie role, wspolne dla serwera i klienta.
 *
 * `admin` widzi wszystko. `user` widzi tylko wlasne analizy w uproszczonym widoku (bez Ustawien,
 * Kosztow, Developera, Mikrofonu i Recenzji). Konta sa dwa i stale (src/config/kontaTestowe.ts) -
 * to projekt roboczy; docelowo model kont sie zmieni. Opis: docs/recenzje.md.
 *
 * Wylacznie stale, typy i male czyste funkcje. Zero DOM, zero API Node.
 */

export const ROLE_KONT = ["admin", "user"] as const;
export type RolaKonta = (typeof ROLE_KONT)[number];

export function czyRolaKonta(wartosc: unknown): wartosc is RolaKonta {
  return typeof wartosc === "string" && (ROLE_KONT as readonly string[]).includes(wartosc);
}

/** Odpowiedz GET /api/auth/me i POST /api/auth/login. */
export interface OdpowiedzKonta {
  username: string;
  role: RolaKonta;
}
